import Vue from 'vue'
import Router from 'vue-router'
import AuthService from '@/services/authService'
import NotFound from '@/pages/PageNotFound'
import Home from '@/pages/PageHome'
import Auth from '@/pages/PageAuth'
import AccountConfirmation from '@/pages/PageAccountConfirmation'
import Feed from '@/pages/PageFeed'
import About from '@/pages/PageAbout'
import Rules from '@/pages/PageRules'
import Guild from '@/pages/PageGuild'
import LeaderBoard from '@/pages/PageLeaderBoard'
import Tournaments from '@/pages/PageTournaments'
import MatchList from '@/pages/PageMatchList'
import Match from '@/pages/PageMatch'
import User from '@/pages/PageUser'
import MyAccount from '@/pages/PageMyAccount'
import Admin from '@/pages/PageAdmin'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      component: NotFound
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth
    },
    {
      path: '/account-confirmation/:hash',
      name: 'AccountConfirmation',
      component: AccountConfirmation
    },
    {
      path: '/feed',
      name: 'Feed',
      component: Feed
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/rules',
      name: 'Rules',
      component: Rules
    },
    {
      path: '/guild',
      name: 'Guild',
      component: Guild
    },
    {
      path: '/leaderboard',
      name: 'LeaderBoard',
      component: LeaderBoard
    },
    {
      path: '/tournaments',
      name: 'Tournaments',
      component: Tournaments
    },
    {
      path: '/matchs',
      name: 'MatchList',
      component: MatchList
    },
    {
      path: '/matchs/:id',
      name: 'Match',
      component: Match
    },
    {
      path: '/user/:username',
      name: 'User',
      component: User
    },
    {
      path: '/me',
      name: 'MyAccount',
      component: MyAccount,
      beforeEnter: (to, from, next) => {
        if (!AuthService.isLoggedIn()) {
          console.log('isLoggedIn : ' + AuthService.isLoggedIn())
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      beforeEnter: (to, from, next) => {
        if (!AuthService.isLoggedIn()) {
          console.log('isLoggedIn : ' + AuthService.isLoggedIn())
          next('/')
        } else {
          next()
        }
      }
      // secure: true
    }
  ],
  mode: 'history'
})

/* router.beforeEach((to, from, next) => {
  // Look at all routes
  router.options.routes.forEach((route) => {
    // If this is the current route and it's secure
    if (to.matched[0].name === route.name && route.secure) {
      // Verify that the user isn't logged in
      if (!AuthService.isLoggedIn()) {
        console.log('isLoggedIn : ' + AuthService.isLoggedIn())
        next('/')
      }
    }
  })
  next()
}) */

export default router



// WEBPACK FOOTER //
// ./src/router/index.js